export const restrictedPath = [
    "/settings-jack",
    "/bank-account", 
    "/notifications",
    "/plans",
    "/category",
    "/customize-receipt",
    "/payment-cycle",
    "/dev-tools",
  ];